import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';

import {TargetGroup} from 'shared/models/target-groups/target-group';
import {TargetGroupsListRepository} from '../repositories/target-groups-list.repository';

@Injectable()
export class TargetGroupsListService {

  constructor(private targetGroupsListRepository: TargetGroupsListRepository) { }

  public getAllTargetGroups(): Observable<Array<TargetGroup>> {
    return this.targetGroupsListRepository.getAllTargetGroups();
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/target-groups/target-groups-list/services/target-groups-list.service.ts